/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_LabelInputs */

const en_directory_ai_tools_studio_label = /** @type {(inputs: Directory_Ai_Tools_Studio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video generator`)
};

const zh_directory_ai_tools_studio_label = /** @type {(inputs: Directory_Ai_Tools_Studio_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频生成器`)
};

/**
* | output |
* | --- |
* | "Video generator" |
*
* @param {Directory_Ai_Tools_Studio_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_label = /** @type {((inputs?: Directory_Ai_Tools_Studio_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_label(inputs)
	return zh_directory_ai_tools_studio_label(inputs)
});
export { directory_ai_tools_studio_label as "directory.ai_tools.studio.label" }